module.exports = __webpack_public_path__ + "static/frontUserNew/img/inner-list01.4a83b98a.png";